import {
  Add,
  Apps,
  EmojiEmotions,
  Gif,
  Send,
  StickyNote2,
} from '@mui/icons-material';
import { IconButton, Stack, TextField, Typography } from '@mui/material';
import React, { useMemo } from 'react';

import { MessageList } from './Components/MessageList';
import { useChatController } from './index.controller';
import { ChatProps } from './index.types';

export function ChatView(props: ChatProps) {
  const {
    messages,
    sending,
    message,
    setMessage,
    editingMessageId,
    editingContent,
    setEditingContent,
    textFieldRef,
    isMobile,
    messagesWithMetadata,
    startEdit,
    cancelEdit,
    saveEdit,
    sendMessage,
  } = useChatController(props);

  const {
    onDelete,
    newMessagePlaceholder,
    messageHeaderExtraComponent: MessageHeaderExtraComponent,
  } = props;

  const messagesComponent = useMemo(
    () => (
      <MessageList
        messagesWithMetadata={messagesWithMetadata}
        editingMessageId={editingMessageId}
        editingContent={editingContent}
        setEditingContent={setEditingContent}
        startEdit={startEdit}
        cancelEdit={cancelEdit}
        saveEdit={saveEdit}
        sending={sending}
        onDelete={onDelete}
        messageHeaderExtraComponent={MessageHeaderExtraComponent}
      />
    ),
    [
      MessageHeaderExtraComponent,
      cancelEdit,
      editingContent,
      editingMessageId,
      messagesWithMetadata,
      onDelete,
      saveEdit,
      sending,
      setEditingContent,
      startEdit,
    ],
  );

  return (
    <>
      <Stack flexGrow={1} direction="column-reverse" overflow="auto">
        {messages?.length ? (
          messagesComponent
        ) : (
          <Typography variant="caption" textAlign="center" p={2}>
            No messages
          </Typography>
        )}
      </Stack>
      <Stack
        direction="row"
        flexShrink={0}
        p={2}
        gap={1}
        borderTop="1px solid"
        borderColor="divider"
      >
        {false && (
          <IconButton disabled>
            <Add />
          </IconButton>
        )}
        <TextField
          ref={textFieldRef}
          multiline
          fullWidth
          size="small"
          autoFocus
          disabled={sending}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
            if (!isMobile && !e.shiftKey && e.key === 'Enter') {
              sendMessage();
            }
          }}
          placeholder={newMessagePlaceholder || 'Type a message...'}
        />
        <IconButton disabled={sending} onClick={() => sendMessage()}>
          <Send />
        </IconButton>
        {false && (
          <>
            <IconButton disabled>
              <Gif />
            </IconButton>
            <IconButton disabled>
              <StickyNote2 />
            </IconButton>
            <IconButton disabled>
              <EmojiEmotions />
            </IconButton>
            <IconButton disabled>
              <Apps />
            </IconButton>
          </>
        )}
      </Stack>
    </>
  );
}
